/* Kkumi product card — JS twin (window.KKCard).
 *
 * Cards rendered at runtime (the wishlist grid, the wishlist recommendations
 * rail) build the SAME markup as snippets/kkumi-product-card-shell.liquid and
 * apply the SAME state rules as snippets/kkumi-product-card-v3.liquid, so a
 * card looks and behaves identically wherever it comes from. Change the
 * Liquid → change this file in the same commit (and vice versa). Styles:
 * assets/kkumi-product-card-v3.css.
 *
 * Copy + rules are merchant settings (Theme settings → Kkumi product cards),
 * emitted on window.__kkCardCfg in layout/theme.liquid; the literals below
 * are only fallbacks so a card still renders if the config is missing.
 *
 *   var s = KKCard.state(product, { money: fn(cents) });  // rules → labels
 *   el.innerHTML = KKCard.html({ ...fields });            // fields → markup
 *   KKCard.button({ label, href | submit | action, secondary, attrs })
 *
 * Every string that reaches markup is escaped with window.KKEsc; only the
 * *HTML fields (built by the caller from trusted pieces) pass through raw.
 */
(function () {
  'use strict';
  if (window.KKCard) return;

  var CFG = window.__kkCardCfg || {};
  var C = CFG.copy || {};
  function pick(k, d) { return (C[k] != null && C[k] !== '') ? C[k] : d; }
  var COPY = {
    tagSoldOut: pick('tagSoldOut', 'Sold out'),
    tagPreorder: pick('tagPreorder', 'Pre-order'),
    tagLow: pick('tagLow', 'Low stock'),
    tagSale: pick('tagSale', 'Sale'),
    tagBundle: pick('tagBundle', 'Bundle'),
    tagNew: pick('tagNew', 'New'),
    tagBest: pick('tagBest', 'Bestseller'),
    tagVote: pick('tagVote', '\u2726 Vote'),
    badge: pick('badge', '[count] [options]'),
    badgeItems: pick('badgeItems', '[count] items'),
    badgeItem: pick('badgeItem', '[count] item'),
    qtyOption: pick('qtyOption', 'Pack size'),
    noReviews: pick('noReviews', 'No reviews yet'),
    ratingAria: pick('ratingAria', 'Rated [value] out of 5 from [count] reviews'),
    notePartial: pick('notePartial', '[sold] of [total] [options] sold out'),
    noteLow: pick('noteLow', 'Only [count] left across all [options]'),
    noteLowOne: pick('noteLowOne', 'Only [count] left'),
    noteShips: pick('noteShips', 'Ships [date]'),
    from: pick('from', 'from'),
    bundle: pick('bundle', 'bundle'),
    save: pick('save', '-[percent]%'),
    saveUpto: pick('saveUpto', 'up to -[percent]%'),
    ctaOptions: pick('ctaOptions', 'Choose options'),
    ctaAdd: pick('ctaAdd', 'Add to cart'),
    ctaPreorder: pick('ctaPreorder', 'Pre-order'),
    ctaNotify: pick('ctaNotify', 'Notify me'),
    ctaAdding: pick('ctaAdding', 'Adding\u2026'),
    wishAdd: pick('wishAdd', 'Add to wishlist'),
    wishRemove: pick('wishRemove', 'Remove from wishlist')
  };
  var LOW_AT = Number(CFG.lowAt) > 0 ? Number(CFG.lowAt) : 5;
  function tagList(csv, dflt) {
    return String(csv == null ? dflt : csv).toLowerCase().split(',')
      .map(function (t) { return t.trim(); }).filter(Boolean);
  }
  var NEW_TAGS = tagList(CFG.newTags, 'new, new-arrival');
  // Badge-rule lists: a setting the merchant cleared is an empty list (as in
  // the Liquid); the defaults only stand in when the config is missing.
  function cfgList(key, dflt) { return tagList(key in CFG ? (CFG[key] || '') : null, dflt); }
  var COLOUR_WORDS = cfgList('badgeColourWords', 'colour, color');
  var COLOUR_ON = cfgList('badgeColourOn', 'sleeve');
  var SIZE_WORDS = cfgList('badgeSizeWords', 'size');
  var BEST_TAGS = tagList(CFG.bestTags, 'bestseller, best-seller');

  var esc = window.KKEsc; // canonical shared escaper (assets/kkumi-esc.js, loaded before this file)
  function fill(tpl, map) {
    var out = String(tpl);
    for (var k in map) { if (Object.prototype.hasOwnProperty.call(map, k)) out = out.split('[' + k + ']').join(String(map[k])); }
    return out;
  }

  /* ---- Hearts — twin of snippets/kkumi-hearts.liquid ------------------- */
  var HEART = 'M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z';
  function hearts(rating, size, cls) {
    size = size || 14;
    var r = Math.max(0, Math.min(5, Number(rating) || 0));
    var full = Math.floor(r);
    var frac = Math.round((r - full) * 100);
    var partial = false;
    if (frac >= 98) full += 1;
    else if (frac >= 3) partial = true;
    var attrs = ' width="' + size + '" height="' + size + '" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"';
    var out = '<span class="kk-hearts' + (cls ? ' ' + cls : '') + '" style="display:inline-flex;align-items:center;gap:2px;line-height:1;" aria-hidden="true">';
    for (var i = 1; i <= 5; i++) {
      if (i <= full) out += '<svg class="kk-hearts__heart kk-hearts__heart--full"' + attrs + ' fill="currentColor"><path d="' + HEART + '"/></svg>';
      else if (partial && i === full + 1) out += '<svg class="kk-hearts__heart kk-hearts__heart--partial"' + attrs + '><path d="' + HEART + '" fill="currentColor" style="clip-path: inset(0 ' + (100 - frac) + '% 0 0);"/><path d="' + HEART + '" fill="none"/></svg>';
      else out += '<svg class="kk-hearts__heart kk-hearts__heart--empty"' + attrs + ' fill="none"><path d="' + HEART + '"/></svg>';
    }
    return out + '</span>';
  }

  /* ---- Rules — twin of the Liquid in kkumi-product-card-v3 -------------
   * p = {
   *   title, cardTitle?, type?, available, isCandidate?, isPreorder?,
   *   preorderDate? (already formatted), preorderNote?, isBundle?, bundleItems?,
   *   tags: [..], priceVaries?,
   *   options: [{ name, values: [..] }]  — every option, in order,
   *   variants: [{ available, price (cents), compareAt (cents), options: [..]
   *                (the variant's value per option, same order),
   *                tracked?, qty? }]
   * }
   * opts.money(cents) → formatted string (the caller owns the shop format). */
  // Display name for an option — twin of snippets/kkumi-option-label.liquid.
  // Bundle / combined-listing apps name options after their component
  // ("Palette Outer Sleeves (Colour)", "Galaxy Outer Sleeves - 25 Pack"):
  // a bracketed part is the real name, else a leading product-title
  // prefix (plus its separator) is dropped. Clean names pass through.
  function optionLabel(raw, productTitle) {
    var name = String(raw || '').trim();
    if (!name) return name;
    // Same as the Liquid: the text after the LAST "(" up to its ")".
    var open = name.lastIndexOf('(');
    if (open >= 0 && name.indexOf(')') >= 0) {
      var inner = name.slice(open + 1).split(')')[0].trim();
      if (inner) return inner;
    }
    var t = String(productTitle || '').trim();
    if (t && t.length < name.length && name.slice(0, t.length).toLowerCase() === t.toLowerCase()) {
      var rest = name.slice(t.length).trim().replace(/^[-–—:·|/]\s*/, '');
      if (rest) return rest;
    }
    return name;
  }
  // The wishlist's saved-variant line: every choice WITH its option name —
  // "Colour: Blue Hour · Pack size: 50" — because bare values ("Pink / Pink",
  // "50") are ambiguous. selectedOptions = [{ name, value }] (Storefront API).
  // Names go through optionLabel; a Quantity option reads as the merchant's
  // qtyOption ("Pack size") so its value can't read as a cart quantity; a
  // combined option ("Bag colour | Tweezers" = "Pink / No") is split into its
  // parts. LEGACY: only wishlist items saved on an old combined-option bundle
  // still hit this; the PDP split picker was removed.
  function variantLabel(selectedOptions, productTitle) {
    var parts = [];
    function push(name, value) {
      // "Include Tweezers?" reads as a question before a colon — drop the "?".
      var label = String(name || '').trim().replace(/\?+$/, '').trim();
      if (/^(quantity|qty|pack quantity)$/i.test(label)) label = COPY.qtyOption;
      parts.push(label ? label + ': ' + value : value);
    }
    (selectedOptions || []).forEach(function (o) {
      var value = String((o && o.value) || '').trim();
      var raw = String((o && o.name) || '').trim();
      if (!value || value === 'Default Title' || /^title$/i.test(raw)) return;
      var label = optionLabel(raw, productTitle);
      var names = label.replace(/\s\|\s/g, ' / ').split(' / ');
      var values = value.split(' / ');
      if (names.length > 1 && names.length === values.length) {
        names.forEach(function (n, i) { push(n, values[i]); });
      } else {
        push(label, value);
      }
    });
    return parts.join(' \u00b7 ');
  }
  // The [options] word for the badge / notes, or '' when the option doesn't
  // count: a size option (never a pack size), or a colour option on a colour
  // product. The matched merchant word is pluralised ("colour" → "colours").
  // See state() for the rule; same as the Liquid card.
  function badgeWord(name, colourProduct) {
    var n = String(name || '').toLowerCase().trim();
    if (/quantity|qty|pack|amount/.test(n)) return '';
    var has = function (w) { return n.indexOf(w) >= 0; };
    var w = SIZE_WORDS.filter(has)[0] || (colourProduct ? COLOUR_WORDS.filter(has)[0] : '') || '';
    if (!w || /s$/.test(w)) return w;
    if (/[^aeiou]y$/.test(w)) return w.slice(0, -1) + 'ies';
    return w + 's';
  }
  function state(p, opts) {
    opts = opts || {};
    var money = opts.money || function (c) { return window.KKMoney.fromCents(c); };
    var variants = p.variants || [];
    var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase().trim(); });
    var isBundle = !!p.isBundle || tags.some(function (t) { return t === 'bundle' || t.indexOf('bundle:') >= 0; });

    // Title: the custom.card_title metafield when set, else the full title.
    var title = (p.cardTitle || '').trim() || String(p.title || '');

    // One pass over the variants.
    var avail = 0, stock = 0, countable = true, saleN = 0, maxPct = 0, saleMin = 0, minV = null;
    variants.forEach(function (v) {
      if (!v.available) return;
      avail++;
      if (v.tracked && v.qty != null) stock += Number(v.qty) || 0; else countable = false;
      if (!minV || v.price < minV.price) minV = v;
      if (v.compareAt > v.price) {
        saleN++;
        var pct = Math.round((v.compareAt - v.price) * 100 / v.compareAt);
        if (pct > maxPct) maxPct = pct;
        if (!saleMin || v.price < saleMin) saleMin = v.price;
      }
    });
    if (isBundle) saleN = 0;
    var wholeSale = saleN > 0 && saleN === avail;
    var partSale = saleN > 0 && !wholeSale;
    var isLow = !!p.available && countable && avail > 0 && stock > 0 && stock <= LOW_AT;

    // The badge option: options badge + "x of y sold out". Only COLOURS on
    // colour products (type or title names one — sleeves, by default) and
    // SIZES on any product (never a pack size) count; a kit's bag
    // attachments, flavours, pack sizes… get no badge and no note — the PDP
    // picker shows those. First qualifying option wins. Same rule as the
    // Liquid card; bundles keep their "[count] items" badge.
    var productWords = (String(p.type || '') + ' ' + String(p.title || '')).toLowerCase();
    var colourProduct = !COLOUR_ON.length || COLOUR_ON.some(function (w) { return productWords.indexOf(w) >= 0; });
    var optList = p.options || [];
    var opt = null, optIndex = -1, optPlural = '';
    for (var oi = 0; oi < optList.length && !opt; oi++) {
      var o = optList[oi];
      if (!o || !o.values || o.values.length < 2) continue;
      var w = badgeWord(optionLabel(o.name, p.title), colourProduct);
      if (w) { opt = o; optIndex = oi; optPlural = w; }
    }
    var optCount = opt ? opt.values.length : 0;
    var soldOut = 0;
    if (opt) {
      opt.values.forEach(function (val) {
        var ok = variants.some(function (v) { return v.available && v.options && v.options[optIndex] === val; });
        if (!ok) soldOut++;
      });
    }
    var badge = '';
    if (isBundle && p.bundleItems > 0) badge = fill(p.bundleItems === 1 ? COPY.badgeItem : COPY.badgeItems, { count: p.bundleItems });
    else if (optCount > 1) badge = fill(COPY.badge, { count: optCount, options: optPlural });

    // The one tag — availability beats promotion.
    var hasTag = function (list) { return tags.some(function (t) { return list.indexOf(t) >= 0; }); };
    var tag = '', tagSale = false;
    if (p.isCandidate) tag = COPY.tagVote;
    else if (!p.available) tag = COPY.tagSoldOut;
    else if (p.isPreorder) tag = COPY.tagPreorder;
    else if (isLow) tag = COPY.tagLow;
    else if (saleN > 0) { tag = COPY.tagSale; tagSale = true; }
    else if (isBundle) tag = COPY.tagBundle;
    else if (hasTag(NEW_TAGS)) tag = COPY.tagNew;
    else if (hasTag(BEST_TAGS)) tag = COPY.tagBest;

    // The one note line.
    var note = '', notePre = false;
    if (p.available && p.isPreorder) {
      note = p.preorderDate ? fill(COPY.noteShips, { date: p.preorderDate }) : (p.preorderNote || '');
      notePre = true;
    } else if (isLow) {
      note = optCount > 1 ? fill(COPY.noteLow, { count: stock, options: optPlural }) : fill(COPY.noteLowOne, { count: stock });
    } else if (p.available && soldOut > 0) {
      note = fill(COPY.notePartial, { sold: soldOut, total: optCount, options: optPlural });
    }

    // Price row.
    var minPrice = variants.length ? Math.min.apply(null, variants.map(function (v) { return v.price; })) : 0;
    var maxPrice = variants.length ? Math.max.apply(null, variants.map(function (v) { return v.price; })) : 0;
    var priceVaries = p.priceVaries != null ? !!p.priceVaries : maxPrice > minPrice;
    var out = {
      title: title,
      tag: tag,
      tagSale: tagSale,
      badge: badge,
      note: note,
      notePre: notePre,
      onSale: saleN > 0,
      priceLabel: isBundle ? COPY.bundle : (priceVaries ? COPY.from : ''),
      priceAmount: money(minPrice),
      priceSale: false,
      priceCompare: '',
      priceSave: ''
    };
    if (isBundle) {
      var bv = minV || variants[0];
      if (bv && bv.compareAt > bv.price) {
        out.priceCompare = money(bv.compareAt);
        out.priceSave = fill(COPY.save, { percent: Math.round((bv.compareAt - bv.price) * 100 / bv.compareAt) });
      }
    } else if (wholeSale) {
      out.priceAmount = money(minV.price);
      out.priceSale = true;
      out.priceCompare = money(minV.compareAt);
      out.priceSave = fill(COPY.save, { percent: Math.round((minV.compareAt - minV.price) * 100 / minV.compareAt) });
    } else if (partSale) {
      out.priceLabel = COPY.from;
      out.priceAmount = money(saleMin);
      out.priceSale = true;
      out.priceSave = fill(COPY.saveUpto, { percent: maxPct });
    }
    return out;
  }

  /* ---- Button — the card's one full-width CTA ------------------------- */
  // b = { label, href? , submit? (bool), secondary?, attrs?: {name: value} }
  function button(b) {
    var cls = 'button ' + (b.secondary ? 'button--secondary' : 'button--primary') + ' kk-pc__btn';
    var attrs = '';
    var a = b.attrs || {};
    for (var k in a) { if (Object.prototype.hasOwnProperty.call(a, k) && a[k] != null) attrs += ' ' + k + '="' + esc(a[k]) + '"'; }
    if (b.href) return '<a class="' + cls + '" href="' + esc(b.href) + '"' + attrs + '>' + esc(b.label) + '</a>';
    return '<button type="' + (b.submit ? 'submit' : 'button') + '" class="' + cls + '"' + (b.submit ? ' name="add"' : '') + attrs + '>' + esc(b.label) + '</button>';
  }

  /* ---- Markup — twin of snippets/kkumi-product-card-shell.liquid ------ */
  var SAVED_SVG = '<svg width="12" height="12" viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="' + HEART + '"/></svg>';
  function html(c) {
    var attrs = '';
    var ra = c.rootAttrs || {};
    for (var k in ra) { if (Object.prototype.hasOwnProperty.call(ra, k) && ra[k] != null) attrs += ' ' + k + '="' + esc(ra[k]) + '"'; }
    var media = '';
    if (c.imgSrc) {
      media += '<img class="kk-pc__img kk-pc__img--primary kk-img-skel" src="' + esc(c.imgSrc) + '" alt="' + esc(c.imgAlt || '') + '" loading="lazy">';
      if (c.imgHover) media += '<img class="kk-pc__img kk-pc__img--hover" src="' + esc(c.imgHover) + '" alt="" loading="lazy">';
    }
    var rc = Number(c.ratingCount) || 0;
    var rv = Number(c.ratingValue) || 0;
    var rating = '';
    if (c.showRating !== false) {
      if (rc > 0) {
        var shown = (Math.round(rv * 10) / 10).toFixed(1);
        rating = '<p class="kk-pc__rating" role="img" aria-label="' + esc(fill(COPY.ratingAria, { value: shown, count: rc })) + '">' +
          hearts(rv, 14, 'kk-pc__hearts') +
          '<span class="kk-pc__rating-num" aria-hidden="true">' + shown + '</span>' +
          '<span class="kk-pc__rating-count" aria-hidden="true">(' + rc + ')</span></p>';
      } else {
        rating = '<p class="kk-pc__rating kk-pc__rating--none">' + hearts(0, 14, 'kk-pc__hearts') + '<span>' + esc(COPY.noReviews) + '</span></p>';
      }
    }
    return '<div class="kk-pc kk-pc--v3' + (c.oos ? ' kk-pc--oos' : '') + (c.rootClass ? ' ' + c.rootClass : '') + '"' + attrs + '>' +
      '<div class="kk-pc__media kk-pc__media--' + (c.ratio || 'square') + (c.imgSrc ? '' : ' kk-pc__media--empty') + '">' +
        media +
        (c.mediaExtraHTML || '') +
        (c.tag ? '<span class="kk-pc__tag' + (c.tagSale ? ' kk-pc__tag--sale' : '') + '">' + esc(c.tag) + '</span>' : '') +
        (c.heartHTML || '') +
        (c.badge ? '<span class="kk-pc__badge">' + esc(c.badge) + '</span>' : '') +
        (c.edition ? '<span class="kk-pc__edition"' + (c.editionStyle ? ' style="' + esc(c.editionStyle) + '"' : '') + '>' + esc(c.edition) + '</span>' : '') +
      '</div>' +
      '<div class="kk-pc__body">' +
        '<h3 class="kk-pc__name"><a class="kk-pc__link" href="' + esc(c.url) + '"' + (c.linkTitle ? ' title="' + esc(c.linkTitle) + '"' : '') + '>' + esc(c.title) + '</a></h3>' +
        (c.variantLabel ? '<p class="kk-pc__variant">' + esc(c.variantLabel) + '</p>' : '') +
        (c.choices ? '<p class="kk-pc__variant kk-pc__choices">' + esc(c.choices) + '</p>' : '') +
        rating +
        (c.note ? '<p class="kk-pc__note' + (c.notePre ? ' kk-pc__note--pre' : '') + '">' + esc(c.note) + '</p>' : '') +
        (c.saved ? '<p class="kk-pc__saved">' + SAVED_SVG + '<span>' + esc(c.saved) + '</span></p>' : '') +
        (c.bodyExtraHTML || '') +
        '<div class="kk-pc__foot">' +
          '<p class="kk-pc__price">' +
            (c.priceLabel ? '<span class="kk-pc__price-label">' + esc(c.priceLabel) + '</span>' : '') +
            '<span class="kk-pc__price-amt' + (c.priceSale ? ' kk-pc__price-amt--sale' : '') + '">' + esc(c.priceAmount) + '</span>' +
            (c.priceCompare ? '<s class="kk-pc__price-compare">' + esc(c.priceCompare) + '</s>' : '') +
            (c.priceSave ? '<span class="kk-pc__save">' + esc(c.priceSave) + '</span>' : '') +
          '</p>' +
          (c.ctaHTML ? '<div class="kk-pc__cta">' + c.ctaHTML + '</div>' : '') +
        '</div>' +
      '</div>' +
      (c.afterHTML || '') +
    '</div>';
  }

  // Edition / version pill from product tags (edition:Soju Ver., tag-colour:#…,
  // tag-text-colour:#…) — same convention as the Liquid card.
  function editionFromTags(tags) {
    var out = { label: '', style: '' };
    var bg = '', fg = '';
    (tags || []).forEach(function (raw) {
      var t = String(raw).trim(), lower = t.toLowerCase();
      var val = t.indexOf(':') >= 0 ? t.slice(t.indexOf(':') + 1).trim() : '';
      if (/^(edition|version|volume|badge):/.test(lower)) out.label = val;
      else if (/^tag-colou?r:/.test(lower)) bg = val;
      else if (/^tag-text-colou?r:/.test(lower)) fg = val;
    });
    // Colours from merchant tags go into a style attribute: keep only plain
    // colour tokens (#hex, rgb(), names) so a tag can't smuggle in more CSS.
    var safe = /^(#[0-9a-f]{3,8}|[a-z]+|rgba?\([\d\s.,%]+\))$/i;
    if (bg && safe.test(bg)) out.style += 'background:' + bg + ';';
    if (fg && safe.test(fg)) out.style += 'color:' + fg + ';';
    return out;
  }

  window.KKCard = {
    copy: COPY,
    state: state,
    html: html,
    button: button,
    hearts: hearts,
    editionFromTags: editionFromTags,
    optionLabel: optionLabel,
    variantLabel: variantLabel
  };
})();
